<template>
  <v-dialog
    scrollable
    v-model="show"
    width="1500"
    v-if="leg"
  >
    <DeleteDialog
      v-if="showDeleteDialog"
      :visible="showDeleteDialog"
      @close="
        showDeleteDialog = false;
        notDeletedAlertText = '';
        refresh();
      "
      @delete-confirmed="onDelete"
      title="Delete Expedition?"
      :warning="notDeletedAlertText"
    >
    </DeleteDialog>
    <PortFormDialog
      v-if="showPortFormDialog"
      :visible="showPortFormDialog"
      @close="
        showPortFormDialog = false;
        refresh();
      "
      :leg-id="leg.id"
      :port-id="selectedPortId"
      :platform-id="leg.platform_id"
    >
    </PortFormDialog>
    <LegFormDialog
      v-if="showLegFormDialog"
      :visible="showLegFormDialog"
      :title="title"
      @saved="
        showLegFormDialog = false;
        refresh();
      "
      @close="
        showLegFormDialog = false;
        refresh();
      "
      :leg-id="leg.id"
    />

    <v-card>
      <v-card-title class="osis-title-bar">
        <div style="color: white">
          {{ title }}
        </div>
        <v-spacer></v-spacer>
        <v-btn
          elevation="0"
          color="white"
          icon
          @click.stop="show = false"
        >
          <v-icon> {{$icons.mdiClose}} </v-icon>
        </v-btn>
      </v-card-title>
      <ErrorAlert
        v-if="errorAlertText"
        @close="errorAlertText = ''"
      >
        {{ errorAlertText }}
      </ErrorAlert>
      <v-tabs
        v-if="showTabs"
        v-model="tab"
        centered
        icons-and-text
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab>Info <v-icon>{{$icons.mdiInformationOutline}}</v-icon>
        </v-tab>
        <v-tab>{{ eventTab }}<v-icon>{{$icons.mdiMapMarkerDistance}}</v-icon>
        </v-tab>
        <v-tab>{{ fileTab }}<v-icon>{{$icons.mdiFileOutline}}</v-icon>
        </v-tab>
        <v-tab>{{ linkTab }}<v-icon>{{$icons.mdiLinkVariant}}</v-icon>
        </v-tab>
        <v-tab>{{ externalIdTab }}<v-icon>{{$icons.mdiArrowRightThin}}</v-icon>
        </v-tab>
        <v-tab v-if="this.$store.state.token || this.$store.state.name">{{ deliverableTab }}<v-icon>{{$icons.mdiCubeSend}}</v-icon>
        </v-tab>
      </v-tabs>
      <v-card-text style="height: 1100px">
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <LegInfo
                  v-if="Object.keys(leg).length !== 0"
                  :leg="leg"
                  @show_departure_port_call="showDepartureDialog"
                  @show_return_port_call="showReturnDialog"
                  @show_stopover_port_call="showStopoverDialog"
                  @add_port_call="addPortDialog"
                />
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn
                  class="osis-button"
                  v-if="patchPermission"
                  @click="startEditingLeg"
                >
                  Edit
                  <v-icon
                    class="osis-orange"
                    right
                  > {{$icons.mdiPencil}} </v-icon>
                </v-btn>
                <v-btn
                  v-if="deletePermission"
                  class="osis-button"
                  @click="showDeleteDialog = true"
                >
                  Delete
                  <v-icon
                    class="osis-red"
                    right
                  > {{$icons.mdiDeleteOutline}} </v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div v-if="tab === 1">
                  <Events
                    :leg-id="legId"
                    @events-refreshed="refresh"
                  >
                  </Events>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div v-if="tab === 2">
                  <Files
                    :leg-id="legId"
                    @files-refreshed="refresh"
                  >
                  </Files>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div v-if="tab === 3">
                  <DataLinks
                    :leg-id="legId"
                    @links-refreshed="refresh"
                  >
                  </DataLinks>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div v-if="tab === 4">
                  <ExternalIds
                    :leg-id="legId"
                    @external-ids-refreshed="refresh"
                  >
                  </ExternalIds>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div v-if="tab === 5">
                  <Deliverables
                    :leg-id="legId"
                    @deliverables-refreshed="refresh"
                  >
                  </Deliverables>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <v-spacer></v-spacer>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import permission from '@/mixins/permissions'
import apiRequests from '@/mixins/apiRequests'
import ExternalIds from '@/components/ExternalIds/ExternalIds.vue'

export default {
  name: 'LegOverviewDialog',
  props: ['visible', 'legId', 'preferredTab'],
  components: {
    DeleteDialog: () => import('@/components/DeleteDialog.vue'),
    PortFormDialog: () => import('@/components/PortFormDialog.vue'),
    LegInfo: () => import('@/components/Legs/LegInfo.vue'),
    LegFormDialog: () => import('@/components/Legs/LegFormDialog.vue'),
    ErrorAlert: () => import('@/components/ErrorAlert.vue'),
    Events: () => import('@/components/Events/Events.vue'),
    Files: () => import('@/components/Files/Files.vue'),
    DataLinks: () => import('@/components/DataLinks/DataLinks.vue'),
    Deliverables: () => import('@/components/Deliverables/Deliverables.vue'),
    ExternalIds,
  },
  mixins: [permission, apiRequests],
  data() {
    return {
      showTabs: false,
      leg: {},
      eventTab: '',
      fileTab: '',
      linkTab: '',
      patchPermission: false,
      deletePermission: false,
      tab: null,
      notDeletedAlertText: '',
      selectedPortId: null,
      showPortFormDialog: false,
      showLegFormDialog: false,
      showDeleteDialog: false,
      errorAlertText: '',
      mountedByRouter: false,
      externalIdTab: null,
    }
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.closeDialog()
        }
      }
    },
    title: function () {
      return 'Expedition ' + this.leg.name
    }
  },
  watch: {
    'tab': function (newValue) {
      if (this.mountedByRouter) {
        if (newValue == 0 && this.$route.name !== 'Legs') {
          this.$router.push({ name: 'Legs', params: { leg_id: this.legId } })
        }
        else if (newValue == 1 && !this.$route.name.startsWith("LegEvent")) {
          this.$router.push({ name: 'LegEvents', params: { leg_id: this.legId } })
        }
        else if (newValue == 2 && this.$route.name !== 'LegFiles') {
          this.$router.push({ name: 'LegFiles', params: { leg_id: this.legId } })
        }
        else if (newValue == 3 && this.$route.name !== 'LegLinks') {
          this.$router.push({ name: 'LegLinks', params: { leg_id: this.legId } })
        }
        else if (newValue == 4 && this.$route.name !== 'LegExternalIds') {
          this.$router.push({ name: 'LegExternalIds', params: { leg_id: this.legId } })
        }
        else if (newValue == 5 && this.$route.name !== 'LegDeliverables') {
          this.$router.push({ name: 'LegDeliverables', params: { leg_id: this.legId } })
        }
      }
    },
  },
  async beforeMount() {
    if (this.$route.name.startsWith("Leg")) {
      this.mountedByRouter = true
    }
    this.leg = await this.getLeg(this.legId)
    await this.getPermissions()
    this.updateParameter()
    if (this.preferredTab) {
      this.tab = this.preferredTab
    } else if (this.$route.name.startsWith("LegEvent")) {
      this.tab = 1
    } else if (this.$route.name === 'LegFiles') {
      this.tab = 2
    } else if (this.$route.name === 'LegLinks') {
      this.tab = 3
    } else if (this.$route.name === 'LegExternalIds') {
      this.tab = 4
    } else if (this.$route.name === 'LegDeliverables') {
      this.tab = 5
    }
  },
  async mounted() {
  },
  methods: {
    async getPermissions() {
      let permissionsToAsk = {
        'deletePermission': { leg_id: this.legId, action: 'delete' },
        'patchPermission': { leg_id: this.legId, action: 'patch' }
      }
      let permissions = await this.getExpeditionPermissionFromApi(permissionsToAsk)
      this.patchPermission = permissions.patchPermission.permission
      this.deletePermission = permissions.deletePermission.permission
    },
    async refresh() {
      this.leg = await this.getLeg(this.leg.id)
      this.updateParameter()
    },
    closeDialog() {
      this.$emit('close')
    },
    async startEditingLeg() {
      this.showLegFormDialog = true
    },
    async onDelete() {
      let success = await this.deleteLeg()
      if (success) {
        this.show = false
      }
    },
    updateParameter() {
      this.showTabs = false
      this.eventTab = 'Events (' + this.leg.event_count + ')'
      this.fileTab = 'Files (' + this.leg.related_file_count + ')'
      this.linkTab = 'Links (' + this.leg.related_data_link_count + ')'
      this.externalIdTab = 'Ids (' + this.leg.external_id_count + ')'
      this.deliverableTab = 'Deliverables (' + this.leg.deliverable_count + ')'
      this.showTabs = true
    },
    async getLeg(id) {
      const requestParams = {
        method: "GET",
        url: 'expeditions/' + id,
      }
      try {
        const res = await this.osisApiRequest(requestParams)
        const data = await res.json()
        return data
      } catch (error) {
        console.log(error)
      }
    },
    async deleteLeg() {
      const requestParams = {
        method: "DELETE",
        url: 'expeditions/' + this.leg.id,
      }
      try {
        const res = await this.osisApiRequest(requestParams)
        if (res.status == 204) {
          return true
        }
        else {
          const data = await res.json()
          this.notDeletedAlertText = data.message
          return false
        }
      }
      catch (error) {
        console.log(error)
      }
    },
    showDepartureDialog() {
      console.log('showDepartureDialog')
      this.selectedPortId = this.leg.departure_port_call.id
      this.showPortFormDialog = true
    },
    showReturnDialog() {
      this.selectedPortId = this.leg.return_port_call.id
      this.showPortFormDialog = true
    },
    showStopoverDialog(id) {
      this.selectedPortId = id
      this.showPortFormDialog = true
    },
    addPortDialog() {
      this.selectedPortId = null
      this.showPortFormDialog = true
    },
  },
}
</script>

<style >
</style>

